<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" v-if="info">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
            <div class="profile-info d-sm-flex align-items-center">

                <div class="title m-0">
                    <h1 class="text-black fw-medium mb-8">{{ info.firstname }} {{ info.lastname }}</h1>
                    <span class="d-block text-dark-emphasis mb-0 small">
                        {{ info.id }}
                    </span>
                </div>
            </div>
            <div class="border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30"></div>
            <div class="d-flex align-items-center justify-content-between">
                <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('form.section.personal_information') }}</h5>
                <router-link to="profile/update-password" v-if="update_password_enabled"
                    class="d-inline-block text-decoration-none lh-1 text-muted fw-medium">
                    <i class="ph-duotone ph-pencil text-black position-relative top-1 fs-16 me-1"></i>
                    {{ $t('cta.update_password') }}
                </router-link>
            </div>
            <ul class="info mt-25 ps-0 mb-0 list-unstyled">
                <li class="position-relative">
                    <div class="icon text-success rounded-circle text-center">
                        <i class="ph ph-envelope-simple"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.email.label') }}</span>
                    <a :href="`mailto:${info.email}`" class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none">
                        {{ info.email }}
                    </a>
                </li>
                <li class="position-relative" v-if="info.invitation_id == null">
                    <div class="icon text-warning-light rounded-circle text-center">
                        <i class="ph ph-phone"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.phone.label') }}</span>
                    <a :href="`tel:${info.phone_number}`" class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none">
                        {{ info.phone_number }}
                    </a>
                </li>
            </ul>
            <!-- RIGHT TO ERASURE -->
        </div>
    </div>
</template>
  
<script lang="ts">
import config from "@/utils/const/config";
import { UserInfo, CenterWithPermission } from "@/utils/models/user.model";
import stateStore from "@/utils/store";
import { defineComponent } from "vue";

export default defineComponent({
    name: "ProfileAnagraph",
    data: function() {
        return {
            info: stateStore.user?.info,
            centers: stateStore.centers()
        } as {
            info?: UserInfo,
            centers: CenterWithPermission[]
        }
    },
    methods: {
        rightToErasureRequest() {}
    },
    computed: {
        update_password_enabled():boolean {return !config.feature.otp_login }
    }
});
</script>